import { Controller } from '@hotwired/stimulus'
import { on, off } from '../lib/events'

export default class extends Controller {
  static targets = ['content']

  contentTargetConnected = () => {
    this.open = true
    on('click', this.closeMenu)
  }

  closeMenu = (event) => {
    if (this.canCloseMenu(event)) {
      event.preventDefault()
      this.closeCompletely()
    }
  }

  closeCompletely = () => {
    this.element.innerHTML = ''
    this.open = false
    off('click', this.closeMenu)
  }

  canCloseMenu = (event) => {
    return !event.target.closest('[data-controller="turbo-dropdown"]') && this.open
  }
}
